module.exports = __webpack_public_path__ + "static/media/estate-clarity-login-options-new.224aa126.jpg";